<template>
    <div class="fuel-card-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Discount Fuel Card in partnership with Discount Fuel Services
                </div>
                <div class="logo">
                    <img src="/images/fuel-discount-logo-small.png">
                </div>
            </div>
            <div class="box-1">
                <h1>We find the best fuel card for your business so you don't have to.</h1>
                <p>
                    We work with all the top fuel providers and are trusted by 50,000+ businesses
                </p>
                <div>
                    <a href="https://www.fuelcardservices.com/fensa/" target="_blank" class="btn-primary _lg" @click="partnerLinkClicked()">
                        Apply Now
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
                <img src="/images/offers-and-promotions-fuelcard-header.png">
            </div>
            <div class="box-2">
                <div class="columns">
                    <div class="col">
                        <div>
                            <h2>Reduced fuel costs</h2>
                            <p>
                                Discounted fuel prices, saving you as much as 10p per litre.
                            </p>
                        </div>
                    </div>
                    <div class="col">
                        <div>
                            <h2>Better security</h2>
                            <p>
                                Prevent fuel fraud with cards linked to vehicle/driver. Restrict what products can be purchased.
                            </p>
                        </div>
                    </div>
                    <div class="col">
                        <div>
                            <h2>Less administration</h2>
                            <p>
                                HMRC compliant invoices so no need to keep receipts.
                            </p>
                        </div>
                    </div>
                </div>
                <div>
                    <!--<a href="https://www.fuelcardservices.com/fensa/#callback" target="_blank" class="btn-primary-outline _lg mr-3">-->
                        <!--Request a Callback-->
                    <!--</a>-->
                    <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Fuel Card Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like some more information on signing up for a fuel card',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 18,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Fuel card enquiry',
                'value': 'Fuel card enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Fuel card`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Fuel card partner link clicked',
          'value': 'Fuel card partner link clicked',
        });
      },
    },
};
</script>
